var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useRef, useState } from 'react';
import { apiGetListCase } from '@/actions/CaseActions';
import { usePromiseDoingCallback } from '@/hooks/async/loading/usePromiseDoingCallback';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { locationStateKey } from '@/pages/case/CaseList/const';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { get } from '@/utils/libs/lodash/get';
import { stringifyUrl } from '@/utils/libs/query-string/stringify';
import { createRandomStringId } from '@/utils/libs/uuid/createId';
export const useCaseListFetchList = (options) => {
    const { dispatch, locationState, pathname, queryParamsRef, unmountRef } = options;
    const history = useNavigate();
    const doingApiRef = useRef();
    // ページのデータを管理
    const [caseListPageData, changeCaseListPageData] = useState(() => get(locationState, locationStateKey) || null);
    /**
     * history.replace 先の取得
     * @param changeQueryParam クエリのパラメータを変更する関数
     */
    const getReplaceUrl = useCallback((changeQueryParam) => {
        const parseParam = changeQueryParam
            ? changeQueryParam(queryParamsRef.current || {})
            : queryParamsRef.current;
        return {
            param: parseParam,
            url: stringifyUrl({ query: parseParam, url: pathname }),
        };
    }, [pathname, queryParamsRef]);
    /**
     * 一覧 データ取得 + state, URL更新
     * @param replaceUrl history.replace 先の URL
     * @param params APIのクエリに追加するパラメータ
     * @param page 取得するページ番号
     */
    const fetchCaseListPageDataBase = useCallback((replaceUrl, params, page) => __awaiter(void 0, void 0, void 0, function* () {
        const doingApiId = createRandomStringId();
        doingApiRef.current = doingApiId;
        try {
            // APIの実行
            const res = yield wrapDispatch(dispatch, apiGetListCase({ query: Object.assign(Object.assign({}, (params || {})), { page }) }, {}));
            if (doingApiRef.current !== doingApiId || unmountRef.current || !res) {
                return;
            }
            const { payload: { list, pagination }, } = res;
            let newState = null;
            // state 更新
            changeCaseListPageData((prev) => {
                newState = {
                    caseListData: [...((prev === null || prev === void 0 ? void 0 : prev.caseListData) || []), ...list],
                    currentPage: pagination.current_page,
                    isLastPage: pagination.current_page === pagination.total_page,
                };
                return newState;
            });
            // URL（location.state） 更新
            history.replace(replaceUrl, {
                state: { [locationStateKey]: newState },
            });
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }), [dispatch, history, unmountRef]);
    // 一覧データ取得 ローディング制御
    const { callbackPromiseEvent: fetchCaseListPageData, doing: loading } = usePromiseDoingCallback({
        promiseEvent: fetchCaseListPageDataBase,
        unmountRef,
    });
    return {
        caseListPageData,
        changeCaseListPageData,
        fetchCaseListPageData,
        getReplaceUrl,
        hasInitialCaseListPageData: caseListPageData !== null,
        isLoadingCaseList: loading,
    };
};
